import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA, MatDialog,
  MatDialogConfig, MatDialogRef
} from '@angular/material/dialog';
import { Router } from '@angular/router';

export interface CampaignsForFieldDialogData {
  tagCategory: {
    id: string;
    name: string;
    groupName: string;
  };
  targetType?: 'EntityConnectionType' | 'EntityType';
  targetTypeId?: string;
}

@Component({
  selector: 'app-campaigns-for-field-dialog',
  template: `
<app-modal>
  <h1 class="h2">Campaigns using this field</h1>
  <p class="modal-intro mt-0050 mb-0050">
    <span class="d-inline-block modal-breadcrumbs">
      {{field.groupName | propercase}} &rsaquo; <strong>{{field.name | propercase }}</strong>
    </span>
  </p>
  <p class="modal-intro mt-0050 mb-0150">
    Listed below are all campaigns belonging to your organization. Those that
have the “{{field.name}}” field active are marked with a check. Click on a
campaign to be directed to the “Info” page for that campaign.
   </p>
  <app-campaign-visibility-filter
  [objectType]="'TagCategory'"
  [objectTypeId]="field.id"
  (itemSelected)="itemSelected($event)"
  ></app-campaign-visibility-filter>
</app-modal>
`
})

export class CampaignsForFieldDialog {

  field = this.data?.tagCategory;

  static open(dialog: MatDialog, data: MatDialogConfig<CampaignsForFieldDialogData>) {
    return dialog.open(CampaignsForFieldDialog, data);
  }

  constructor(
    private router: Router,
    public dialogRef: MatDialogRef<CampaignsForFieldDialog>,
    @Inject(MAT_DIALOG_DATA) public data: CampaignsForFieldDialogData) { }

  close() {
    return this.dialogRef.close();
  }

  /** */
  itemSelected(item: { campaignId: string }) {
    const queryParams = {
      editMode: true,
      campaignId: item.campaignId,
      connectionTypeId: null,
      entityTypeId: null,
    };

    if (this.data.targetType === 'EntityConnectionType') {
      queryParams.connectionTypeId = this.data.targetTypeId;
    }

    if (this.data.targetType === 'EntityType') {
      queryParams.entityTypeId = this.data.targetTypeId;
    }

    this.close();
    this.router.navigate(['/campaign/customize/fields'], { queryParams });
  }
}
